import {Collection, Radio} from 'backbone';
import CarType from '../models/CarType';

class CarTypes extends Collection.extend({
  url: '/api/cartypes',
  model: CarType,
}) {}

export default CarTypes;
